<div class="page-content">
  
  <one-breadcrumbs>
    <one-breadcrumb-element *ngFor="let breadcrumb of breadcrumbs; last as isLast; first as isFirst">
      <span *ngIf="isFirst" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationPage()">
        {{ breadcrumb.label }}
      </span>
      <span *ngIf="!isFirst && !isLast" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationDetailsPage()">
        {{ breadcrumb.label }}
      </span>
      <span *ngIf="isLast" class="mat-small">
        {{ breadcrumb.label }}
      </span>
      <mat-icon>arrow_forward</mat-icon>
    </one-breadcrumb-element>
  </one-breadcrumbs>

  <div class="customer-detail-container">

    <p class="cd-header">{{ customerTitle }}</p>

    <div class="cd-card-container">

  
      <mat-card mat-card oneCard class="cd-card-list cd-onecard" style="margin-right: 12px;">

        <mat-card-title class="cd-mat-card">
          <div class="cd-card-title">Account</div>
        </mat-card-title>

        <mat-card-content style="display: block;">

          <form [formGroup]="accFormGroup">

            <div class="cd-item">

              <div class="cd-title">Name</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.AccountName">
                {{ customerData.AccountName }}
              </div>

              <div *ngIf="showEditControls">

                <input formControlName="formAccName" class="cd-edit-value" />

                <mat-error *ngIf="accFormGroup.controls['formAccName'].invalid" style="margin-top: 5px;">
                  Name must be at least 2 characters.
                </mat-error>

              </div>

            </div>

            <div class="cd-item" style="margin-top: 10px;">

              <div class="cd-title">ID</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.AccountId">
                {{ customerData.AccountId }}
              </div>

              <div *ngIf="showEditControls">

                <input formControlName="formAccID" class="cd-edit-value" />

                <mat-error *ngIf="accFormGroup.controls['formAccID'].invalid" style="margin-top: 5px;">
                  ID must be at least 2 characters.
                </mat-error>

              </div>

            </div>

             <div class="cd-item" style="margin-top: 10px;">

              <div class="cd-title">Note</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.NoteText">
                {{  appUtil.formatDateWithTimeUptoSec(customerData.NoteDate) }} <br/>
                {{customerData.NoteText}}
              </div>

               <div *ngIf="showEditControls">

                <input formControlName="formNote" class="cd-edit-value" />
              </div> 

            </div>

          </form>
          
        </mat-card-content>
        
        <div>
          
          <mat-card-actions *ngIf="!userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="position: absolute; bottom: 0px; right: 0px;">
            <button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</button>
          </mat-card-actions>                                                                                                                                     

          <mat-card-actions *ngIf="!showEditControls && userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="position: absolute; bottom: 0px; right: 0px;">
            <button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</button>
            <button one-secondary-button mat-stroked-button [disabled]="isSetCom || isNotiStat" (click)="openEditForm()">Edit</button>
          </mat-card-actions>
  
          <mat-card-actions *ngIf="showEditControls && userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="position: absolute; bottom: 0px; right: 0px;">
            <button one-secondary-button mat-stroked-button class="cd-close" (click)="closeEditForm()">Cancel</button>
            <button color="primary" mat-flat-button [disabled]="accFormGroup.invalid" (click)="editFormDetails()">Save</button>
          </mat-card-actions>

        </div>

      </mat-card>

      <mat-card oneCard class="cd-card-list cd-onecard" style="margin-left: 12px;">

        <mat-card-title style="margin-bottom: 0px;">
          <div class="cd-card-title">Communication</div>
          
          <div class="cd-chip-status">
            <mat-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline" [title]="customerData.AccountStatus"> {{ displayStatus(customerData.AccountStatus) }}</mat-chip>
          </div>
        </mat-card-title>

        <mat-card-content style="display: block;">

          <div class="cd-item">
            <div class="cd-title">Date sent</div>
            <div class="cd-value" [title]="customerData.AccountDateSent">{{ appUtils.formatDateWithTime(customerData.AccountDateSent) }}</div>
          </div>

          <div class="cd-item">
            <div class="cd-title">Date delivered</div>
            <div class="cd-value" [title]="customerData.AccountDateDelivered">{{ appUtils.formatDateWithTime(customerData.AccountDateDelivered) }}</div>
          </div>

          <div class="cd-item">
            <div class="cd-title">Date read</div>
            <div class="cd-value" [title]="customerData.AccountDateRead">{{ appUtils.formatDateWithTime(customerData.AccountDateRead) }}</div>
          </div>

          <div class="cd-item">
            <div class="cd-title">Feedback received</div>
            <div class="cd-value" [title]="customerData.AccountFeedbackReceived">{{ appUtils.formatDateWithTime(customerData.AccountFeedbackReceived) }}</div>
          </div>

          <div class="cd-item">
            <div class="cd-title">Submitter</div>
            <div class="cd-value truncate-text" [title]="customerData.AccountSubmitter">{{ customerData.AccountSubmitter }}</div>
          </div>

        </mat-card-content>

      </mat-card>

    </div>

    <div>
      <mat-card oneCard class="cd-card-customer">

        <mat-card-title class="cd-mat-card" style="margin-top: 1rem; min-height: 0px;">
          <div class="cd-feedback-title">Notification</div>
        </mat-card-title>
        
        <mat-card-title class="cd-mat-card" style="margin-bottom: 1rem; margin-top: 2rem; min-height: 0px;" *ngIf="title && title.length > 0">        
          <div class="cd-feedback-title">{{ title }}</div>
        </mat-card-title>

        <mat-card-content>

          <hr class="horizontal-line" *ngIf="title && title.length > 0">

          <div class="cd-feedback-list">

            <mat-card-title style="margin-bottom: 0px; justify-content: space-between; min-height: 0px;">
              <div class="cd-feedback-list-title" *ngIf="customerNotificationData.MessageTitle && customerNotificationData.MessageTitle.length > 0">
                {{ customerNotificationData.MessageTitle }},
                <span *ngIf="customerData.DateSent" style="margin-left: 5px;">Sent {{ appUtils.formatDateWithTime(customerData.DateSent) }}</span>
              </div>
            </mat-card-title>
  
            <div class="cd-feedback-list-subject" *ngIf="customerNotificationData.MessageBody && customerNotificationData.MessageBody.length > 0">
              <div [innerHTML]="customerNotificationData.MessageBody"></div>
            </div>
            
          </div>
          
          <hr class="horizontal-line">
          
          <div class="cd-feedback-list" style="display: flex; flex-direction: column">
            
            <div class="cd-feedback-list-title">
              Attachments
            </div>

            <div class="file-upload-multiple" style="margin-bottom: 0px;">
              
              <ng-container *ngIf="!isNoAttachmentsVisible()">
                
                <!--Global Attachments-->
                <div *ngFor="let attachment of customerNotificationData.NotificationDocuments">
                  <div class="cd-files-list" *ngIf="attachment.Title && attachment.Title.length > 0">
                    <div class="single-file">
                      <div class="info" (click)="downloadDocument(attachment.PIMID, attachment.FileExtension)">
                        <mat-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(attachment.FileExtension) }}</mat-icon>
                        <span style="margin-left:10px">
                          <span class="name">
                            {{ attachment.Title }}.{{ attachment.FileExtension }} 
                            <span class="globalTag">Global</span>
                          </span>
                          <p class="size">{{ formatBytes(attachment.FileSize) }}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Local Attachments-->
                <div *ngFor="let attachmentData of customerNotificationData.NotificationAttachments">
                  <div class="cd-files-list" *ngIf="attachmentData.FileName">
                    <div class="single-file">
                      <div class="info" (click)="downloadAttachment(attachmentData.FileName, NotificationId)">
                        <mat-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(attachmentData.FileName) }}</mat-icon>
                        <span style="margin-left:10px">
                          <span class="name">
                            {{ attachmentData.FileName }}
                            <span class="localTag">Local</span>
                          </span>
                          <p class="size">{{ formatBytes(attachmentData.FileSize) }}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </ng-container>

              <ng-container *ngIf="isNoAttachmentsVisible()">
                <p style="color: red; font-style: italic; margin: 0;">
                  No attachments added.
                </p>
              </ng-container>

            </div>

          </div>

          <hr class="horizontal-line">

          <!-- Feedback -->
          <div class="cd-feedback-list" [hidden]="(ackComment || customerData.Submitter !== customerData.CustomerContactEmail)  && customerData.Submitter !== undefined" *ngIf="customerNotificationData.CustomerFeedbackItems && customerNotificationData.CustomerFeedbackItems.length > 0">
            
            <div class="cd-feedback-list-title">
              Feedback
            </div>

            <div *ngFor="let feedbackdatas of customerNotificationData.CustomerFeedbackItems; let i = index">
              
              <div class="cd-feedback-list-checkbox" *ngIf="feedbackdatas.FeedbackItemType == 'Checkbox'">
                <section class="example-section"  style="margin-block: 24px;">
                  
                  <p *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseCheck"> 
                    <mat-checkbox disabled [checked]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel">
                      
                      {{ feedbackdatas.FeedbackItemLabel }}

                      <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                        ({{feedbackdatas.FeedbackItemMandatory}})
                      </span>

                    </mat-checkbox>
                  </p>
                  
                  <ng-template #noFeedbakResponseCheck>
                    <p>
                      <mat-checkbox disabled>

                        {{ feedbackdatas.FeedbackItemLabel }}

                        <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                          ({{feedbackdatas.FeedbackItemMandatory}})
                        </span>

                      </mat-checkbox>
                    </p>
                  </ng-template>

                </section>
              </div>
              
              <div *ngIf="feedbackdatas.FeedbackItemType == 'Question'">
                
                <div>

                  <span>{{ feedbackdatas.FeedbackItemLabel }}</span>

                  <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                    ({{feedbackdatas.FeedbackItemMandatory}})
                  </span>

                </div>
                
                <div *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseQuest">
                  <input disabled [value]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel" class="cd-feedback-list-answer" placeholder="Your answer" />
                </div>
                
                <ng-template #noFeedbakResponseQuest>
                  <input disabled [value]="" class="cd-feedback-list-answer" placeholder="Your answer" />
                </ng-template>

              </div>
              
              <div *ngIf="feedbackdatas.FeedbackItemType == 'Dropdown'" style="margin-top: 10px;">

                <p>
                  {{ feedbackdatas.FeedbackItemLabel }} 

                  <span style="font-weight: bold;">(Dropdown)</span>

                  <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                    ({{feedbackdatas.FeedbackItemMandatory}})
                  </span>
                </p>

                <div *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseQuest">
                  <p style="font-weight: bold;">
                    {{customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel}}
                  </p>
                </div>

                <ng-template #noFeedbakResponseQuest>
                  <mat-form-field>

                    <mat-label>Select...</mat-label>

                    <mat-select oneSelect appearance="outline" size="big">
                      <mat-option  [value]="opts" *ngFor="let opts of feedbackdatas.FeedbackItemDropdown" disabled>
                        {{opts}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>
                </ng-template>

              </div>

              <div *ngIf="feedbackdatas.FeedbackItemType == 'Radio'" style="margin-top: 10px;">

                <p>
                  {{ feedbackdatas.FeedbackItemLabel }} 

                  <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                    ({{feedbackdatas.FeedbackItemMandatory}})
                  </span>
                </p>

                <div *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponse">
                  <mat-radio-group class="radio-group" oneCustomKeyboardHandler aria-labelledby="radio-group-label">
                    <mat-radio-button
                      disabled
                      class="radio-button" 
                      [value]="optsRadio"
                      *ngFor="let optsRadio of feedbackdatas.FeedbackItemRadio" 
                      [checked]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel === optsRadio"
                    >
                      {{ optsRadio }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <ng-template #noFeedbakResponse>
                  <mat-radio-group  class="radio-group" oneCustomKeyboardHandler aria-labelledby="radio-group-label">
                    <mat-radio-button  class="radio-button" [value]="optsRadio" *ngFor="let optsRadio of feedbackdatas.FeedbackItemRadio" disabled>
                      {{ optsRadio }}
                    </mat-radio-button>
                  </mat-radio-group>
                </ng-template>

              </div>
            <div *ngIf="feedbackdatas.FeedbackItemType == 'Attachment'" style="margin-top: 10px;">
                 <p>
                  {{ feedbackdatas.FeedbackItemLabel }} 

                  <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                    ({{feedbackdatas.FeedbackItemMandatory}})
                  </span>
                </p>
                <div class="cd-files-list">
                  <div class="single-file">
                    <div class="info" *ngIf="customerData.AccountFeedbackResponseItems[i]?.FeedbackResponseItemLabel?.fileName" (click)="downloadAttachment(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName, NotificationId, customerData.AccountNotificationId, 'customerFeedbackAttachment')">
                      <mat-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName) }}</mat-icon>
                      <span style="margin-left:10px">
                        <span class="name">
                          {{ customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName }}
                        <span class="localTag">Local</span>
                        </span>
                        <p class="size">{{ formatBytes(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileSize) }}</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Feedback user details -->
          <div *ngIf="(accountFeedbackSubmissionDetails.length!=0)&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedFirstName')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedLastName')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedEmail')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedCountry')&&
          accountFeedbackSubmissionDetails.IsNonDialogUser==='TRUE'">
          <!-- && accountFeedbackSubmissionDetails.Type==='SBN' -->
            <hr class="horizontal-line">

            <div class="cd-feedback-list">
              
              <div class="cd-feedback-list-title">
                Feedback user details
              </div>

              <ul class="feedback-user-details">
                <li><strong>Location:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedCountry}}</li>
                <li><strong>Email:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedEmail}}</li>
                <li><strong>First name:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedFirstName}}</li>
                <li><strong>Middle name (Optional):</strong> {{accountFeedbackSubmissionDetails.CustomerAddedMiddleName}}</li>
                <li><strong>Last name:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedLastName}}</li>
              </ul>

            </div>
          </div>
        </mat-card-content>

      </mat-card>
    </div>
    
    <!-- Recipients Table -->
    <dl-contacts-table></dl-contacts-table>

  </div>
  
</div>
  